import { lazy } from 'react';

export const CorChainPageLazy = lazy(() => import('./CorChainPage'));
